/** Consecutive automatic refresh failures still showing the last valid snapshot. */
export const MAX_PRESERVED_REFRESH_FAILURES = 4;
